import { CONTRACT_BASE_URL } from "../../../constants";
import { getToken } from "../../../context/authContext";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { IShipmentTrackingResponse } from "./models";

const defaultProvide = async () => await getToken();

const SHIPPING_PATH = "shipping/api/shipping";

export const trackShipment = (
  contractId: string
): Promise<IShipmentTrackingResponse> => {
  const url = `${CONTRACT_BASE_URL}${SHIPPING_PATH}/${contractId}/track`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};
